// extracted by css-extract-rspack-plugin
export default {"backLink":"mexs5","illustration":"mejcW"};